import { versions } from "./versions";
import { routeConfig } from "../app/shared/utilities/pages-config";
import { LandingPageComponent } from "../app/landing/components/landing-page/landing-page.component";

/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const environment = {
  envName: "test",
  production: true,
  api_base_url: "https://api.testing.filkhedma.net",
  google_analytics_key: "UA-120632985-2",
  faceBookId: "256226715112676",
  google_gtm_key: "GTM-NQDT44C",
  google_gtm_auth: "WZZN7FM1yz2HqHMd4-1HoA",
  google_gtm_env: "env-7",
  ...versions,
  applyRollbar: false,
  defaultRoute: '/home/',
  firebase: {}
};
